module.exports = __webpack_public_path__ + "img/美妆-7.77251686.png";